import React from 'react';

function ShipmentTimeline({ currentStatus }) {
    const statuses = [
        "Scheduled",
        "Picked Up",
        "In-Land",
        "Waiting CC",
        "Intl. Transit",
        "Arrived",
        "Delivered"
    ];

    const getStatusColor = (status) => {
        if (statuses.indexOf(status) < statuses.indexOf(currentStatus)) {
            return 'bg-green-500 border-green-700 hover:bg-green-600 hover:border-green-800';
        } else if (status === currentStatus) {
            return 'bg-yellow-500 border-yellow-700 hover:bg-yellow-600 hover:border-yellow-800';
        } else {
            return 'bg-white border-blue-500 hover:border-blue-600';
        }
    };

    return (
        <div className="flex items-center pt-4 pb-4 bg-white w-full">
            {statuses.map((status, index) => (
                <React.Fragment key={index}>
                    <div className="flex flex-col items-center flex-shrink-0 relative group" style={{ height: '90px' }}>
                        <div className={`w-6 h-6 rounded-full border-2 transition-all duration-300 ${getStatusColor(status)} absolute top-1/2 transform -translate-y-1/2`} title={status}></div>
                        <div className="text-xs text-center w-28 absolute top-1/2 mt-7 transform rotate-45 group-hover:underline cursor-pointer">{status}</div>

                    </div>
                    {index !== statuses.length - 1 && (
                        <div className="flex-grow h-1.5 bg-gradient-to-r from-blue-300 to-blue-400 mx-2"></div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}


export default ShipmentTimeline;
